import { exchActPrizeInfo } from '@tencent/wphk-act-base-cgi';

/**
 * 查询活动执行信息
 * @param exchActidList 活动id列表
 * @returns 活动执行信息
 */
export async function getExchActList(exchActidList: string[]) {
  const data = await exchActPrizeInfo({ exchActidList });
  const exchActidListInfo = data.exchActidList || [];
  return exchActidListInfo;
}
